import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import useAuthStore from '../stores/authStore';
import './ProtectedRoutes.css';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = useAuthStore(state => state.user);
  const role = useAuthStore(state => state.role);
  const setUser = useAuthStore(set => set.setUser);
  const fetchUserAccess = useAuthStore(set => set.fetchUserAccess);
  const clearAccess = useAuthStore(set => set.clearAccess);
  const isAccessLoading = useAuthStore(state => state.isAccessLoading);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        localStorage.removeItem('user_access_token');
        localStorage.removeItem('page_access_token');
        localStorage.removeItem('page_access_tokens');
        await fetchUserAccess(currentUser);
      } else {
        clearAccess();
      }

      if (isMounted) {
        setInitializing(false);
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [setUser, fetchUserAccess, clearAccess]);

  useEffect(() => {
    if (!initializing && !isAccessLoading && user && role === 'reviewer') {
      window.location.replace('https://ting-vision-community-review.web.app');
    }
  }, [initializing, isAccessLoading, user, role]);

  if (initializing || isAccessLoading) return (
    <div>
      <h1 className='protectedRoutes__loading'>Loading...</h1>
    </div>
  )

  if (!user) {
    return <Navigate to='/login' state={{ from: `${location.pathname}${location.search}` }} replace />;
  }

  if (role === 'reviewer') {
    return <p>Opening <a href="https://ting-vision-community-review.web.app">Community Review</a>…</p>;
  }


  return children;

};

export default ProtectedRoute;
